import { createIntl, createIntlCache } from "react-intl";
import en_message from "./locales/fa.json";
const cache = createIntlCache();
const locale = "EN";
const intl = createIntl({ messages: en_message, locale }, cache);

// Translate Function
const __t = (str:string, values:object | undefined = {}) => {
  if(!!str) {
    return intl.formatMessage(
      {
        id: str,
        defaultMessage: str,
      },
      values,
    );
  }
  return ""
};

export default __t;

